import React from 'react';
import { makeStyles, Grid } from '@material-ui/core';
import LocalOfferRoundedIcon from '@material-ui/icons/LocalOfferRounded';
import CalendarTodayRoundedIcon from '@material-ui/icons/CalendarTodayRounded';

import { ListCardItem, ListCard } from 'components';
import useSubscription from 'hooks/useSubscription';
import { formatTimestamp } from 'utils/dates';
import { SubscriptionStatus } from 'types';

import SubscriptionCancelDialog from './SubscriptionCancelDialog';
import SubscriptionRenewDialog from './SubscriptionRenewDialog';

const useStyles = makeStyles({
  subscriptionCardsContainer: {
    padding: '16px',
  },
});

interface Props {}

const SubscriptionActionCards: React.FC<Props> = (props) => {
  const classes = useStyles();
  const [isDialogOpen, setDialogOpen] = React.useState(false);

  const { subscription, plan } = useSubscription();
  const isCancelled = subscription?.status === SubscriptionStatus.canceled;
  const renewalDate = formatTimestamp()(subscription!.currentPeriodEnd);
  const planLabel = isCancelled ? 'Previous' : 'Current';
  const dateLabel = subscription?.cancelAtPeriodEnd ? 'Cancels On' : 'Renews On';
  const cancelRenewActionText = subscription?.cancelAtPeriodEnd || isCancelled ? 'Renew' : 'Cancel';
  const actionDialog =
    subscription?.cancelAtPeriodEnd || isCancelled ? (
      <SubscriptionRenewDialog onClose={() => setDialogOpen(false)} isOpen={isDialogOpen} />
    ) : (
      <SubscriptionCancelDialog onClose={() => setDialogOpen(false)} isOpen={isDialogOpen} />
    );

  const planListItems: ListCardItem[] = [
    {
      leftIcon: <LocalOfferRoundedIcon />,
      secondaryText: `${planLabel} Plan`,
      primaryText: `${plan?.nickname}`,
    },
  ];
  const renewDateListItems: ListCardItem[] = [
    {
      leftIcon: <CalendarTodayRoundedIcon />,
      secondaryText: dateLabel,
      primaryText: renewalDate,
      actionText: cancelRenewActionText,
      onActionClick: () => setDialogOpen(true),
    },
  ];

  return (
    <>
      <Grid container spacing={2} className={classes.subscriptionCardsContainer}>
        <Grid item lg={6} md={12} xs={12} style={{ width: '100%' }}>
          <ListCard reverseLabels listItems={planListItems} noCardPadding />
        </Grid>
        <Grid item lg={6} md={12} style={{ width: '100%' }}>
          <ListCard reverseLabels listItems={renewDateListItems} noCardPadding />
        </Grid>
      </Grid>
      {isDialogOpen && actionDialog}
    </>
  );
};

export default SubscriptionActionCards;
